import { z } from "zod";
import { voiceGuesserPhraseLocaleSchema } from "./config.js";

export const createVoiceGuesserGameSchema = z.object({
	phrase_locale: voiceGuesserPhraseLocaleSchema,
});

export type CreateVoiceGuesserGamePayload = z.infer<typeof createVoiceGuesserGameSchema>;
